import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "flowbite-react"
import { FaRegTrashAlt, FaFileExport } from "react-icons/fa";
import DateFormatter from "../dates/DateFormatter";
import DeleteModal from "./DeleteModal";
import ExportModal from "./ExportModal";

const ListRow = ({ list, refreshLists }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);

  return (
    <>
      <Table.Row className="bg-white">
        <Table.Cell>
          <Link
            to={`/lists/${list._id}`}
            className="text-gray-900 hover:underline font-medium"
          >
            {list.name}
          </Link>
        </Table.Cell>
        <Table.Cell>
          {list.count}
        </Table.Cell>
        <Table.Cell>
          <DateFormatter date={list.createdAt} />
        </Table.Cell>
        <Table.Cell>
          <div className="flex gap-2">
            <Button onClick={() => setOpenExportModal(true)}>
              <FaFileExport />
            </Button>
            <Button onClick={() => setOpenModal(true)}>
              <FaRegTrashAlt />
            </Button>
          </div>
        </Table.Cell>
      </Table.Row>
      <DeleteModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        list={list}
        refreshLists={refreshLists}
      />
      <ExportModal
        openModal={openExportModal}
        setOpenModal={setOpenExportModal}
        list={list}
      />
    </>
  )
}

export default ListRow;